import axios from 'axios';
import { message } from 'antd';
import {
  ORDER_API,
} from '../../../constants/API';
import {
  UPDATE_ORDER_LOADING
} from '../types';

function updateOrder(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: UPDATE_ORDER_LOADING,
        updatingOrder: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const putData = {
          ...data,
          userId: userData.id
        };
        await axios.put(`${ORDER_API}/${data.id}`, putData, { headers: {"Authorization" : `Bearer ${accessToken}`} })
        dispatch({
          type: UPDATE_ORDER_LOADING,
          updatingOrder: false
        });
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: UPDATE_ORDER_LOADING,
          updatingOrder: false
        });
        console.log(e);
      }
  }
}
export default updateOrder;
